export default {"src":"/_next/static/media/success-icon.e8f42bfa.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};